import gameMethods from './Games'
import gameIdMethods from './Games.id'

export const GameServices = {
  ...gameMethods,
  id: gameIdMethods
}

export * from './Games.types'
